import {
    BookingSearchStrategyType,
    IBookingSearchStrategyViewModel
} from "./strategies/booking-search.strategy.interface";

export interface IAgencyBookingSearchService {
    resultViewMode: BookingSearchResultViewMode;
    getResultViewModeDescription(viewMode: BookingSearchResultViewMode): string;
    readonly currentStrategy: IBookingSearchStrategyViewModel;
    setCurrentStrategy(strategyType: BookingSearchStrategyType): void;
    readonly searchStrategies: IBookingSearchStrategyViewModel[];
    goToRecentBookings(): Promise<void>;
}

export enum BookingSearchResultViewMode {
    CardsView = 1,
    TableView = 2
}